<template>
    <div class="col-12 col-md-9 col-lg-5">
        <div class="content pages">
            <div class="h5 title">{{ $t('views.dashboard.sections.analytics_pages.title') }}</div>
            <div class="p description">{{ $t('views.dashboard.sections.analytics_pages.description') }}</div>
            <LoadingSection v-if="loading" :showMessage="false" />
            <ul v-else class="stats">
                <li class="stat" :title="p.name" v-for="(p, i) in pages" :key="i">
                    <div class="name">{{ p.name }}</div>
                    <div class="value">{{ p.count }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { formatNumber } from '@/utils/formatting';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: "DashboardPages",
        components: {
            LoadingSection
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(useAccountStore, ['hasAccountStats', 'accountStats']),
            pages() {
                const pageUrl = this.accountStats?.page_url;
                if (!this.hasAccountStats || typeof pageUrl !== 'object' || !pageUrl) return [];
                
                const blacklist = ['undefined', 'null', 'gtm-msr'];
                
                return Object.entries(pageUrl)
                    .filter(([url]) => {
                        const name = String(url || '').toLowerCase();
                        return name && !blacklist.some(term => name.includes(term));
                    })
                    .sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0))
                    .slice(0, 10)
                    .map(([url, count]) => ({ 
                        name: String(url), 
                        count: this.formatNumber(count ?? 0) 
                    }));
            }
        },
        methods: {
            formatNumber
        }
    }
</script>